import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Moon = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M9.9931 7.59381C9.2082 9.32014 7.46878 10.5112 5.4548 10.5043C2.70615 10.4949 0.490756 8.26434 0.500149 5.51569C0.507032 3.5017 1.70996 1.77047 3.44161 0.997381C3.15447 1.6234 2.99378 2.31319 2.99129 3.04152C2.98191 5.78384 5.19728 8.02075 7.94593 8.03015C8.67426 8.03264 9.36513 7.87666 9.9931 7.59381Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 11 11" strokeWidth={1}>{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Moon };